import { useMemo } from "react"
import type { PartnerAddress } from "@stockline/shared/types/crm/partner-address"
import { PARTNER_ADDRESS_TABLE } from "../../../lib/offline/resources/crm/partner-address/db"
import { useAISync } from "../../ai/providers/AISyncProvider"

export interface UsePartnerAddressesFilter {
  partnerId?: string
  isDefault?: boolean
  includeDeleted?: boolean
}

export function usePartnerAddresses(
  filter?: UsePartnerAddressesFilter
): PartnerAddress[] {
  const { reactive } = useAISync()
  const rows = reactive.useQuery<PartnerAddress>(PARTNER_ADDRESS_TABLE, {
    ...(filter?.partnerId ? { partnerId: filter.partnerId } : {}),
    ...(filter?.isDefault !== undefined ? { isDefault: filter.isDefault } : {}),
    orderBy: "-updatedAt",
  })
  const includeDeleted = filter?.includeDeleted
  return useMemo(
    () => (includeDeleted ? rows : rows.filter((r) => !r.deletedAt)),
    [rows, includeDeleted]
  )
}
